var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPtBrinline = function SvgPtBrinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pt-br_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m9 4 8 5-8 5-8-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M9 12.13a3.13 3.13 0 1 0 0-6.261 3.13 3.13 0 0 0 0 6.261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01209F",
    d: "M7.433 8.804c-.544 0-1.07.082-1.564.236a3.13 3.13 0 0 0 5.693 1.755 5.28 5.28 0 0 0-4.129-1.991M12.071 9.6q.057-.292.058-.6a3.13 3.13 0 0 0-6.007-1.236 6.46 6.46 0 0 1 5.95 1.835"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pt-br_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgPtBrinline;